@if (options) {
    <ng-container [formGroup]="selectForm">
        <div
            class="form-control"
            [ngClass]="{ 'm-0:b': !otherSelected }"
        >
            @let select = selectForm.controls.select;
            <select
                formControlName="select"
                [attr.aria-invalid]="select.touched && select.invalid"
                [attr.aria-errormessage]="selectErrorId"
                required
            >
                <option
                    [ngValue]="null"
                    disabled
                >
                    {{ placeholder }}
                </option>
                @for (option of options; track $index) {
                    <option [ngValue]="option['value'] || option">
                        {{ option['label'] || option }}
                    </option>
                }
                <option [ngValue]="'other'">{{ otherOptionLabel }}</option>
            </select>
            <app-error-messages
                formControlName="select"
                [messages]="errorMessages()"
                [errorId]="selectErrorId"
            />
        </div>
        @if (otherSelected) {
            <div class="form-control m-0:b sub-input">
                @let other = selectForm.controls.other;
                <label
                    appReactiveLabel
                    formControlName="other"
                    [for]="'other-input' + id"
                    >{{ pleaseEnterOtherLabel }}</label
                >
                <input
                    [id]="'other-input' + id"
                    type="text"
                    formControlName="other"
                    [placeholder]="pleaseEnterOtherLabel"
                    [attr.aria-invalid]="other.touched && other.invalid"
                    [attr.aria-errormessage]="otherErrorId"
                    required
                />
                <app-error-messages
                    formControlName="other"
                    [messages]="errorMessages()"
                    [errorId]="otherErrorId"
                />
            </div>
        }
    </ng-container>
}
